import { useMutation } from '@tanstack/react-query';
import { AttachmentReportService } from '@/infra/services/attachment';

interface UploadAttachmentParams {
	organization_id: string;
	company_id: string;
	size: number;
	action_plan_id?: string;
	content_type: string;
	file_name: string;
}

const Service = AttachmentReportService.getInstance();

export function useUploadAttachment() {
	return useMutation({
		mutationFn: (params: UploadAttachmentParams) => Service.uploadAttachment(params)
	});
}
